/* eslint-disable no-unused-vars */
import { Dispatch, SetStateAction, useState } from 'react';
import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';

import moment from 'moment';
import {
  formatUSDNoDecimals,
  isBeforeAugustFirst2025,
  USDT
} from '../../../helpers/helperFunctions';
import { Responsive } from '../../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';
import { PackageBundleSubscription } from '../Portfolio.types';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';
import { SendGiftSteps } from './Subscription.types';

export const SubscriptionBundleItem = ({
  item,
  setOpenGiftModal,
  openGiftModal,
  setGiftOrder,
  setStep
}: {
  item: PackageBundleSubscription;
  setOpenGiftModal: Dispatch<SetStateAction<boolean>>;
  openGiftModal: boolean;
  setGiftOrder: Dispatch<SetStateAction<any>>;
  setStep: Dispatch<SetStateAction<SendGiftSteps>>;
}) => {
  const showToolTipCards = (item: any) => {
    const cards = item?.giftedTravelutionSubscriptions?.map(
      (card: any, index: number) => {
        return (
          <div key={index}>
            <CaptionText>UID: {card.user.id}</CaptionText>
            <CaptionText>
              Name: {card.user.name} {card.user.surname}
            </CaptionText>
          </div>
        );
      }
    );
    return cards;
  };

  return (
    <>
      <BoxBig relative>
        <HubImage image={item.product.imageUrl}>
          <H4 color={color.colors.neutral0}>{item?.product?.name}</H4>
        </HubImage>
        <div>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ cursor: 'pointer' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  PRICE
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {isBeforeAugustFirst2025(item?.dateCreated)
                    ? item.price * 0.9
                    : item.price}{' '}
                  <P3 mb='3'>{USDT}</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  DATE OF PURCHASE
                </CaptionText>
                <P1 bold>{moment(item?.dateCreated).format('DD MMM YYYY')}</P1>
              </Td>
              <Td w='20%' wSM='50%'>
                <Button
                  w='100px'
                  h='34px'
                  disabled={item?.remainingTravelutionSubscriptions === 0}
                  onClick={() => {
                    setStep(SendGiftSteps.PAYMENT_METHOD);
                    setGiftOrder(item);
                    setOpenGiftModal(!openGiftModal);
                  }}>
                  SEND GIFT
                </Button>
              </Td>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  REMAINING
                </CaptionText>
                <P1 bold>{item?.remainingTravelutionSubscriptions}</P1>
              </Td>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  SENT{' '}
                  {item?.giftedTravelutionSubscriptions?.length > 0 && (
                    <TextWithTooltip
                      margin='30px 0 8px 0'
                      tooltip={showToolTipCards(item)}
                      width='auto'
                      column='column'
                    />
                  )}
                </CaptionText>

                <P1 bold>{5 - item?.remainingTravelutionSubscriptions}</P1>
              </Td>
            </Tr>
          </div>
          <Flexed column gap='30px'>
            <Responsive style={{ margin: '24px 0' }} between>
              <Flexed mbSM='20' rowSM>
                <P3 caps bold color={color.colors.secondary100} mr='60'>
                  TRAVELUTION BUNDLE SUBSCRIPTION DETAILS
                </P3>
                <P3 flex color={color.colors.secondary100} mr='60'>
                  ORDER ID:{' '}
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.id}
                  </P3>
                </P3>
                <P3 flex color={color.colors.secondary100}>
                  Package ID:
                  <P3 bold ml='2' color={color.colors.secondary100}>
                    {item?.product?.id}
                  </P3>
                </P3>
              </Flexed>
            </Responsive>
          </Flexed>
        </div>
      </BoxBig>
    </>
  );
};
